import { createRequest, titanApi } from "./titanApi";

const extendedApi = titanApi.enhanceEndpoints({ addTagTypes: ["allUsers"] }).injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query({
      query: ({ roles = [] }) => ({
        ...createRequest(`/api/users/getusers`),
        method: "GET",
        params: { roles },
      }),
      providesTags: ["allUsers"],
    }),

    getUserById: builder.query({
      query: (id) => ({
        ...createRequest(`/api/users/getUser/${encodeURIComponent(id)}`),
        method: "GET",
      }),
    }),

    updateUser: builder.mutation({
      query: ({ id, user }) => ({
        ...createRequest(`/api/users/updateUser/${encodeURIComponent(id)}`),
        method: "PUT",
        body: user,
      }),
      invalidatesTags: ["allUsers"],
    }),

    activateUser: builder.mutation({
      query: ({ id, active }) => ({
        ...createRequest(`/api/users/activate/${encodeURIComponent(id)}`),
        method: "PUT",
        body: { active },
      }),
      invalidatesTags: ["allUsers"],
    }),

    deactivateUser: builder.mutation({
      query: ({ id }) => ({
        ...createRequest(`/api/users/deactivate/${encodeURIComponent(id)}`),
        method: "PUT",
      }),
      invalidatesTags: ["allUsers"],
    }),

    deleteUser: builder.mutation({
      query: ({ id }) => ({
        ...createRequest(`/api/users/deleteUser/${encodeURIComponent(id)}`),
        method: "DELETE",
      }),
      invalidatesTags: ["allUsers"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useActivateUserMutation,
  useDeactivateUserMutation,
  useDeleteUserMutation,
  useUpdateUserMutation,
  useGetUsersQuery,
  useGetUserByIdQuery,
} = extendedApi;
